export class ActionPhoto {
    public Photo: string = '';
    public ActionID: number = -1;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}